import { t } from '@lingui/macro';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { NetworkDeviceFilter, TimeRangeFilter, useNetworkDevice, networkDeviceFilterId } from '../../filters';
import { useSummarizedFilterStateById } from '../../../stores/FilterStateStore';
import { LAYOUT_WIDTH } from '../../page-framework/panel-container/PanelContainer';

import {
    NetworkDeviceStatusBreakoutPanel,
    NetworkDeviceCpuUtilizationPanel,
    NetworkDeviceMemoryUtilizationPanel,
    NetworkDeviceSyslogPanel,
    NetworkDevicePropertiesPanel,
} from '../../panels';

export const pageId = 'device-detail';

export default function NetworkDeviceDetailPage() {
    const device = useNetworkDevice();
    const [summarized] = useSummarizedFilterStateById(networkDeviceFilterId);
    const title = summarized?.value;
    const [isAdminUser] = useIsAdminUser();

    return (
        <Page id={pageId}>
            <PageHeader
                title={title}
                titleActions={
                    device &&
                    !device.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link
                                to={`/admin/monitored-infrastructure/${device?.uuid}`}
                                title={t`Edit network device configuration`}
                            >
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <NetworkDeviceFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <NetworkDeviceStatusBreakoutPanel width={LAYOUT_WIDTH.FULL} title={t`Status`} />
                <NetworkDeviceCpuUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`CPU Utilization`} />
                <NetworkDeviceMemoryUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Memory Utilization`} />
                <NetworkDeviceSyslogPanel width={LAYOUT_WIDTH.FULL} title={t`Syslog Events`} />
                <NetworkDevicePropertiesPanel width={LAYOUT_WIDTH.FULL} title={t`Properties`} />
            </PanelContainer>
        </Page>
    );
}
